import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  // The Activation screen keeps the whole rejection, not the server body: its status decides between
  // logging out (404) and the set-password form (422). See src/utils/rejectedResponse.js.
  ...requestCases('PROFILE_ACTIVATE', { success: dataAs('profile_activate'), error: payload => payload }),
});
